import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Welcome } from 'components/common/Welcome/Welcome'
import styles from '../../GMA/AbilityWelcome/AbilityWelcome.module.scss'
import PlayIcon from 'assets/icons/play.svg'
import { getInterest, startInterest } from 'ducks/respondent'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { t } from 'ttag'

const InterestWelcome = () => {
  const { totalQuestions } = useSelector(getInterest, shallowEqual)
  const dispatch = useDispatch()

  return (
    <Welcome
      description={
        <div className={styles.description}>
          <div className={styles.paragraph}>
            {t`The talent assessment is used to better understand which areas of talent are most`}{' '}
            <b>{t`aligned with you.`}</b>{' '}
            {t`This allows you to seek roles that cater to your strengths and potential.`}{' '}
          </div>
          <div className={styles.paragraph}>
            {t`It is therefore important that you`} <b>{t`respond honestly`}</b>{' '}
            {t`to the questions.`}
          </div>
          <div className={styles.paragraph}>
            {t`The test will start when you press “Start the test“.`}
          </div>
        </div>
      }
      totalQuestions={totalQuestions}
      time={t`No time limitation`}
      button={
        <BoldButton
          label={t`Start the test`}
          icon={PlayIcon}
          isIconFirst
          onClick={() => dispatch(startInterest())}
        />
      }
    />
  )
}

export default InterestWelcome
